import { useState } from 'react'
import { useNavigation } from '../../hooks/useNavigation.js'
import { getAppConfig } from '../../config/appConfig.js'
import { resolvePlatformOrigin } from '../../lib/navSearch.js'
import { NavBar } from './NavBar.js'
import { SearchBar } from './SearchBar.js'
import { UserMenu } from './UserMenu.js'
import { MobileNav } from './MobileNav.js'

function HamburgerIcon({ open }: { open: boolean }) {
  return (
    <svg
      className="h-6 w-6"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
      aria-hidden="true"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d={open ? 'M6 18L18 6M6 6l12 12' : 'M4 6h16M4 12h16M4 18h16'}
      />
    </svg>
  )
}

export function Header() {
  const { nav } = useNavigation()
  const platformOrigin = resolvePlatformOrigin(getAppConfig().platformNavigationApiUrl)
  const [mobileOpen, setMobileOpen] = useState(false)

  return (
    <header className="sticky top-0 z-50 border-b border-border bg-surface font-inter">
      <div className="flex h-16 items-center justify-between px-4 sm:px-6 lg:px-8">
        <div className="flex items-center">
          <button
            type="button"
            onClick={() => setMobileOpen((v) => !v)}
            aria-label="Toggle navigation menu"
            aria-expanded={mobileOpen}
            className="mr-2 -ml-2 inline-flex items-center rounded-md p-2 text-subtle hover:bg-surface-hover hover:text-body lg:hidden"
          >
            <HamburgerIcon open={mobileOpen} />
          </button>
          <a href="/" className="mr-6 flex shrink-0 items-center" aria-label="Ethisphere home">
            <img className="h-6 w-auto" src="/img/ethisphere_logo_blue.svg" alt="Ethisphere" />
          </a>
          <NavBar nav={nav} />
        </div>
        <div className="flex items-center">
          <div className="mr-3 hidden lg:block">
            <SearchBar search={nav?.search} platformOrigin={platformOrigin} />
          </div>
          <div className="hidden lg:block">
            <UserMenu platformOrigin={platformOrigin} />
          </div>
        </div>
      </div>
      {mobileOpen && <MobileNav nav={nav} platformOrigin={platformOrigin} />}
    </header>
  )
}
